import { TAGS, api } from "@/store/api.ts"
import {
  IInfoModalHasRead,
  IInfoModalHasReadDto,
  IMarkInfoModalAsReadDto
} from "."

const basePath = "/info-modals"

export const infoModalApi = api.enhanceEndpoints({
  addTagTypes: [TAGS.INFO_MODAL]
})

export const infoModalEndpoints = infoModalApi.injectEndpoints({
  endpoints: (builder) => ({
    getInfoModalHasRead: builder.query<IInfoModalHasRead, IInfoModalHasReadDto>(
      {
        query: ({ type, lang }) => ({
          url: `${basePath}/has-read/${type}/${lang}`,
          method: "GET"
        }),
        providesTags: (_, __, { type, lang }) => [
          { type: TAGS.INFO_MODAL, id: `INFO_MODAL_HAS_READ` },
          { type: TAGS.INFO_MODAL, id: `INFO_MODAL_HAS_READ:${type}:${lang}` }
        ]
      }
    ),
    markInfoModalAsRead: builder.mutation<void, IMarkInfoModalAsReadDto>({
      query: ({ type, lang }) => ({
        url: `${basePath}/mark-read/${type}/${lang}`,
        method: "PATCH"
      }),
      invalidatesTags: (_, __, { type, lang }) => [
        { type: TAGS.INFO_MODAL, id: `INFO_MODAL_HAS_READ:${type}:${lang}` }
      ]
    })
  })
})

export const {
  useGetInfoModalHasReadQuery,
  useMarkInfoModalAsReadMutation,
  useLazyGetInfoModalHasReadQuery
} = infoModalEndpoints
